import {NullableType} from "../Tools";
import {DateTime} from "luxon";
export const UNVEIL = 'UNVEIL';
export const TOGGLE_EDIT = 'TOGGLE_EDIT';
export const TOGGLE_ADD_AIRLINE = 'TOGGLE_ADD_AIRLINE';
export const TOGGLE_MORE = 'TOGGLE_MORE';
export const TOGGLE_CHARTS = 'TOGGLE_CHARTS';
export const TOGGLE_MENU = 'TOGGLE_MENU';
export const TOGGLE_FILTER = 'TOGGLE_FILTER';
export const TOGGLE_STATS = 'TOGGLE_STATS';
export const TOGGLE_TUTORIAL = 'TOGGLE_TUTORIAL';
export const TOGGLE_SETTINGS = 'TOGGLE_SETTINGS';
export const TOGGLE_REGISTER = 'TOGGLE_REGISTER';
export const TOGGLE_RESET = 'TOGGLE_RESET';
export const TOGGLE_VERIFY = 'TOGGLE_VERIFY';
export const TOGGLE_MATRIX = 'TOGGLE_MATRIX';
export const TOGGLE_WHATSNEW = 'TOGGLE_WHATSNEW';
export const TOGGLE_SEARCH = 'TOGGLE_SEARCH';
export const TOGGLE_CONSENT = 'TOGGLE_CONSENT';
export const TOGGLE_POLICY = 'TOGGLE_POLICY';
export const TOGGLE_FEEDBACK = 'TOGGLE_FEEDBACK';
export const TOGGLE_WELCOME = 'TOGGLE_WELCOME';
export const TOGGLE_GLOBE = 'TOGGLE_GLOBE';
export const TOGGLE_TABLES = 'TOGGLE_TABLES';
export const TOGGLE_SHOWCASE = 'TOGGLE_SHOWCASE';
export const TOGGLE_MAP_SELECTION = 'TOGGLE_MAP_SELECTION';
export const RESIZE = 'RESIZE';
export const MAP_NEXT = 'MAP_NEXT';
export const JUMP_TO_MAP = 'JUMP_TO_MAP';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const ENQUEUE = 'ENQUEUE';
export const DEQUEUE = 'DEQUEUE';
export const SET_HOVERED_FLIGHT = 'SET_HOVERED_FLIGHT';
export const SET_PIC = 'SET_PIC';
export const SET_PICS = 'SET_PICS';
export const SET_SETTINGS = 'SET_SETTINGS';
export const SET_HOVERED_CITY = 'SET_HOVERED_CITY';
export const ADD_LOCATIONS = 'ADD_LOCATIONS';
export const ADD_FLIGHT = 'ADD_FLIGHT';
export const ADD_FLIGHTS = 'ADD_FLIGHTS';
export const SET_FLIGHTS = 'SET_FLIGHTS';
export const EDIT_FLIGHT = 'EDIT_FLIGHT';
export const CONVERT_FLIGHTS = 'CONVERT_FLIGHTS';
export const REMOVE_FLIGHT = 'REMOVE_FLIGHT';
export const REMOVE_ALL_FLIGHTS = 'REMOVE_ALL_FLIGHTS';
export const FILTER_FLIGHTS = 'FILTER_FLIGHTS';
export const FORCE_CENTER_MAP = 'FORCE_CENTER_MAP';
export const SET_MAP_REFERENCE_GOOGLE = 'SET_MAP_REFERENCE_GOOGLE';
export const SET_MAP_ZOOM_GOOGLE = 'SET_MAP_ZOOM_GOOGLE';
export const SET_MAP_REFERENCE_LEAFLET = 'SET_MAP_REFERENCE_LEAFLET';
export const SET_MAP_ZOOM_LEAFLET = 'SET_MAP_ZOOM_LEAFLET';
export const PAN_TO = 'PAN_TO';
export const SET_MARKER = 'SET_MARKER';

//interfaces
export interface PositionType { x: number, y: number }
export interface LoginType {
    email: string,
    consent: boolean,
    level: string,
    isSuper?: boolean,
    token: string,
    km: boolean,
    celsius: boolean,
    homeAirport: string,
    images: boolean,
    dateFormat: string
}
export interface TemperatureType {
    actual: number,
    average: number
}
export interface TemperatureScaleType {
    max: number,
    min: number
}

export interface FlightType {
    id: number,
    fromTemp: TemperatureScaleType,
    toTemp: TemperatureScaleType,
    from: string,
    to: string,
    distance: number,
    hours: number,
    minutes: number,
    date: string,
    airline: NullableType<string>,
    plane: string,
    seat: string,
    model: NullableType<string>,
    code: string,
    comment: string,
    leg: string,
    purpose: string,
    class: string,
    trip: number,
    noDay: boolean,
    noYear: boolean,
    fromTimezone: number,
    toTimezone: number,
    hour: string,
    minute: string,
    departure: NullableType<TimeType>,
    arrival: NullableType<TimeType>,
    business: boolean,
    normalized?: boolean
}

export interface NewFlightType {
    id: number,
    from: string,
    to: string,
    date: DateTime,
    airline: NullableType<string>,
    plane: string,
    seat: string,
    model: NullableType<string>,
    code: string,
    comment: string,
    leg: string,
    class: string,
    purpose: string,
    trip: number,
    noDay: boolean,
    noYear: boolean,
    hour: string,
    minute: string,
    departure: NullableType<TimeType>,
    arrival: NullableType<TimeType>,
    business: boolean,
    normalized?: boolean
}

export interface TimeType {
    hour: number,
    minute: number
}

/*{"name":"Helsinki,Finland","lat":60.16985569999999,"lng":24.93837899999994,"continent":"europe"}*/
export interface LocationType {
    city: string,
    country: string,
    lat: number,
    lng: number,
    continent: string,
    airportName: string,
    icao: string,
    climate: string
}

export interface FlightAndPositionType { flight: FlightType, hoveredFlightPosition: PositionType }

export interface DateFilterType {
    min: number,
    max: number
}

export interface LatLngType {lat: number, lng: number}
export interface PicAndLocationType { pic: string, location: string }
export interface SettingsType { km?: boolean, celsius?: boolean, homeAirport?: string, images?: boolean, dateFormat?: string }
export interface DateAndAirlineAndModelAndPurposeType { date: DateFilterType, airline: string, model: string, purpose: string }
export interface CodeAndLocationType { code: string, details: LocationType }
export interface CityAndPositionType { hoveredCity: string, hoveredCityPosition: PositionType }

interface PanToAction {type: typeof PAN_TO, payload: LatLngType}
interface SetMarkerAction {type: typeof SET_MARKER, payload: NullableType<LatLngType>}
interface ToggleChartsAction { type: typeof TOGGLE_CHARTS, payload: number }
interface ToggleMenuAction { type: typeof TOGGLE_MENU, payload: boolean }
interface ToggleFilterAction { type: typeof TOGGLE_FILTER, payload: boolean }
interface ToggleStatsAction { type: typeof TOGGLE_STATS, payload: boolean }
interface ToggleTutorialAction { type: typeof TOGGLE_TUTORIAL, payload: boolean }
interface ToggleSettingsAction { type: typeof TOGGLE_SETTINGS, payload: boolean }
interface ToggleRegisterAction { type: typeof TOGGLE_REGISTER, payload: boolean }
interface ToggleResetAction { type: typeof TOGGLE_RESET, payload: boolean }
interface ToggleVerifyAction { type: typeof TOGGLE_VERIFY, payload: string }
interface ToggleMatrixAction { type: typeof TOGGLE_MATRIX, payload: boolean }
interface ToggleWhatsNewAction { type: typeof TOGGLE_WHATSNEW, payload: boolean }
interface ToggleSearchAction { type: typeof TOGGLE_SEARCH, payload: boolean }
interface ToggleConsentAction { type: typeof TOGGLE_CONSENT, payload: boolean }
interface TogglePolicyAction { type: typeof TOGGLE_POLICY, payload: boolean }
interface ToggleFeedbackAction { type: typeof TOGGLE_FEEDBACK, payload: boolean }
interface ToggleMapSelectionAction { type: typeof TOGGLE_MAP_SELECTION, payload: boolean }
interface ToggleWelcomeAction { type: typeof TOGGLE_WELCOME, payload: number }
interface ToggleGlobeAction { type: typeof TOGGLE_GLOBE,
    /** globe number starting from 1 */
    payload: number }
interface ToggleTablesAction { type: typeof TOGGLE_TABLES, payload: number }
interface ToggleShowcaseAction { type: typeof TOGGLE_SHOWCASE, payload: NullableType<FlightType> }
interface SetMapReferenceGoogleAction { type: typeof SET_MAP_REFERENCE_GOOGLE , payload: any }
interface SetMapReferenceLeafletAction { type: typeof SET_MAP_REFERENCE_LEAFLET , payload: any }
interface SetMapZoomGoogleAction { type: typeof SET_MAP_ZOOM_GOOGLE , payload: number }
interface SetMapZoomLeafletAction { type: typeof SET_MAP_ZOOM_LEAFLET , payload: number }
interface MapNextAction { type: typeof MAP_NEXT , payload: void }
interface JumpToMapAction { type: typeof JUMP_TO_MAP , payload: number }
interface ResizeAction { type: typeof RESIZE , payload: void }
interface UnveilAction { type: typeof UNVEIL , payload: void }
interface ToggleEditAction { type: typeof TOGGLE_EDIT, payload: number }
interface ToggleAddAirlineAction { type: typeof TOGGLE_ADD_AIRLINE, payload: boolean }
interface ToggleMoreAction { type: typeof TOGGLE_MORE, payload: boolean }
interface LoginAction { type: typeof LOGIN, payload: LoginType }
interface LogoutAction { type: typeof LOGOUT, payload: void }
interface ForceCenterMapAction { type: typeof FORCE_CENTER_MAP, payload: void }
interface RemoveAllFlightsAction { type: typeof REMOVE_ALL_FLIGHTS, payload: void }
interface EnqueueAction { type: typeof ENQUEUE, payload: string }
interface DequeueAction { type: typeof DEQUEUE, payload: string }
interface SetHoveredFlightAction { type: typeof SET_HOVERED_FLIGHT, payload: FlightAndPositionType }
interface FilterFlightsAction { type: typeof FILTER_FLIGHTS, payload: DateAndAirlineAndModelAndPurposeType }
interface PicAction { type: typeof SET_PIC, payload: PicAndLocationType }
interface SettingsAction { type: typeof SET_SETTINGS, payload: SettingsType }
interface PicsAction { type: typeof SET_PICS, payload: {} }
interface SetHoveredCityAction { type: typeof SET_HOVERED_CITY, payload: CityAndPositionType }
interface AddFlightsAction { type: typeof ADD_FLIGHTS, payload: FlightType[] }
interface SetFlightsAction { type: typeof SET_FLIGHTS, payload: FlightType[] }
interface AddLocationsAction { type: typeof ADD_LOCATIONS, payload: CodeAndLocationType[] }
interface AddFlightAction { type: typeof ADD_FLIGHT, payload: FlightType }
interface EditFlightAction { type: typeof EDIT_FLIGHT, payload: FlightType }
interface ConvertFlightsAction { type: typeof CONVERT_FLIGHTS, payload: void }
interface RemoveFlightAction { type: typeof REMOVE_FLIGHT, payload: FlightType }

export type ActionType = ToggleChartsAction | ToggleMenuAction | ToggleFilterAction | ToggleStatsAction |
    ToggleTutorialAction | ToggleWhatsNewAction | ToggleGlobeAction | ToggleTablesAction | ToggleShowcaseAction | ResizeAction |
    UnveilAction | ToggleEditAction | LoginAction | LogoutAction | RemoveAllFlightsAction | EnqueueAction | ToggleResetAction |
    DequeueAction | SetHoveredFlightAction | FilterFlightsAction | PicAction | PicsAction | SetFlightsAction |
    SetHoveredCityAction | AddFlightsAction | AddLocationsAction | AddFlightAction | ToggleMapSelectionAction |
    EditFlightAction | RemoveFlightAction | ForceCenterMapAction | MapNextAction | SettingsAction | ToggleVerifyAction |
    SetMapReferenceGoogleAction | SetMapReferenceLeafletAction | SetMapZoomGoogleAction | SetMapZoomLeafletAction | PanToAction |
    SetMarkerAction | ToggleSearchAction | ToggleMoreAction | ToggleFeedbackAction | JumpToMapAction | ToggleConsentAction | TogglePolicyAction |
    ToggleAddAirlineAction | ConvertFlightsAction | ToggleSettingsAction | ToggleRegisterAction | ToggleMatrixAction |
    ToggleWelcomeAction;

//functions
export function panTo(position: LatLngType): PanToAction {
    return {type: PAN_TO, payload: position}
}
export function setMarker(position: LatLngType): SetMarkerAction {
    return {type: SET_MARKER, payload: position}
}
export function setMapReferenceGoogle(map: any): SetMapReferenceGoogleAction {
    return {type: SET_MAP_REFERENCE_GOOGLE, payload: map}
}
export function setMapReferenceLeaflet(map: any): SetMapReferenceLeafletAction {
    return {type: SET_MAP_REFERENCE_LEAFLET, payload: map}
}
export function setMapZoomGoogle(zoom: number): SetMapZoomGoogleAction {
    return {type: SET_MAP_ZOOM_GOOGLE, payload: zoom}
}
export function setMapZoomLeaflet(zoom: number): SetMapZoomLeafletAction {
    return {type: SET_MAP_ZOOM_LEAFLET, payload: zoom}
}
export function jumpToMap(map: number): JumpToMapAction {
    return {type: JUMP_TO_MAP, payload: map}
}
export function mapNext(): MapNextAction {
    return {type: MAP_NEXT, payload: undefined}
}
export function resize(): ResizeAction {
    return {type: RESIZE, payload: undefined}
}
export function unveil(): UnveilAction {
    return {type: UNVEIL, payload: undefined}
}
export function toggleEdit(id: number): ToggleEditAction {
    return {type: TOGGLE_EDIT, payload: id}
}
export function toggleAddAirline(on: boolean): ToggleAddAirlineAction {
    return {type: TOGGLE_ADD_AIRLINE, payload: on}
}
export function toggleMore(on: boolean): ToggleMoreAction {
    return {type: TOGGLE_MORE, payload: on}
}
export function login(details: LoginType): LoginAction {
    return {type: LOGIN, payload: details}
}
export function logout(): LogoutAction {
    return {type: LOGOUT, payload: undefined}
}
export function forceCenterMap(): ForceCenterMapAction {
    return {type: FORCE_CENTER_MAP, payload: undefined}
}
export function toggleGlobe(id: number): ToggleGlobeAction {
    return {type: TOGGLE_GLOBE, payload: id}
}
export function toggleWelcome(id: number): ToggleWelcomeAction {
    return {type: TOGGLE_WELCOME, payload: id}
}
export function toggleTables(id: number): ToggleTablesAction {
    return {type: TOGGLE_TABLES, payload: id}
}
export function toggleCharts(id: number): ToggleChartsAction {
    return {type: TOGGLE_CHARTS, payload: id}
}
export function toggleMenu(on: boolean): ToggleMenuAction {
    return {type: TOGGLE_MENU, payload: on}
}
export function toggleFilter(on: boolean): ToggleFilterAction {
    return {type: TOGGLE_FILTER, payload: on}
}
export function toggleStats(on: boolean): ToggleStatsAction {
    return {type: TOGGLE_STATS, payload: on}
}
export function toggleTutorial(on: boolean): ToggleTutorialAction {
    return {type: TOGGLE_TUTORIAL, payload: on}
}
export function toggleSettings(on: boolean): ToggleSettingsAction {
    return {type: TOGGLE_SETTINGS, payload: on}
}
export function toggleRegister(on: boolean): ToggleRegisterAction {
    return {type: TOGGLE_REGISTER, payload: on}
}
export function toggleReset(on: boolean): ToggleResetAction {
    return {type: TOGGLE_RESET, payload: on}
}
export function toggleVerify(unverifiedEmail: string): ToggleVerifyAction {
    return {type: TOGGLE_VERIFY, payload: unverifiedEmail}
}
export function toggleMatrix(on: boolean): ToggleMatrixAction {
    return {type: TOGGLE_MATRIX, payload: on}
}
export function toggleWhatsNew(on: boolean): ToggleWhatsNewAction {
    return {type: TOGGLE_WHATSNEW, payload: on}
}
export function toggleSearch(on: boolean): ToggleSearchAction {
    return {type: TOGGLE_SEARCH, payload: on}
}
export function toggleConsent(on: boolean): ToggleConsentAction {
    return {type: TOGGLE_CONSENT, payload: on}
}
export function togglePolicy(on: boolean): TogglePolicyAction {
    return {type: TOGGLE_POLICY, payload: on}
}
export function toggleFeedback(on: boolean): ToggleFeedbackAction {
    return {type: TOGGLE_FEEDBACK, payload: on}
}
export function toggleMapSelection(on: boolean): ToggleMapSelectionAction {
    return {type: TOGGLE_MAP_SELECTION, payload: on}
}
export function toggleShowcase(flight: NullableType<FlightType>): ToggleShowcaseAction {
    return {type: TOGGLE_SHOWCASE, payload: flight}
}
export function enqueue(item: string): EnqueueAction {
    return {type: ENQUEUE, payload: item}
}
export function dequeue(item: string): DequeueAction {
    return {type: DEQUEUE, payload: item}
}
export function setHoveredFlight(flightAndPosition: FlightAndPositionType): SetHoveredFlightAction {
    return {type: SET_HOVERED_FLIGHT, payload: flightAndPosition}
}

export function setHoveredCity(cityAndPosition: CityAndPositionType): SetHoveredCityAction {
    return {type: SET_HOVERED_CITY, payload: cityAndPosition}
}

export function addFlight(flight: FlightType): AddFlightAction {
    return {type: ADD_FLIGHT, payload: flight}
}
export function addFlights(flights: FlightType[]): AddFlightsAction {
    return {type: ADD_FLIGHTS, payload: flights}
}
export function setFlights(flights: FlightType[]): SetFlightsAction {
    return {type: SET_FLIGHTS, payload: flights}
}

export function editFlight(flight: FlightType): EditFlightAction {
    return {type: EDIT_FLIGHT, payload: flight}
}
export function convertFlights(): ConvertFlightsAction {
    return {type: CONVERT_FLIGHTS, payload: undefined}
}

export function addLocations(codesAndLocations: CodeAndLocationType[]): AddLocationsAction {
    return {type: ADD_LOCATIONS, payload: codesAndLocations}
}
export function removeFlight(flight: FlightType): RemoveFlightAction {
    return {type: REMOVE_FLIGHT, payload: flight}
}
export function removeAllFlights(): RemoveAllFlightsAction {
    return {type: REMOVE_ALL_FLIGHTS, payload: undefined}
}
/*
 export function updateFlight(id, flight) {
 return {type: 'UPDATE_FLIGHT', payload: {id: id, flight: flight}}
 }
 */
export function filterFlights(dateAndAirlineAndModelAndPurpose: DateAndAirlineAndModelAndPurposeType): FilterFlightsAction {
    return {type: FILTER_FLIGHTS, payload: dateAndAirlineAndModelAndPurpose}
}
export function setPic(picAndLocation: PicAndLocationType): PicAction {
    return {type: SET_PIC, payload: picAndLocation}
}
export function setPics(pics: {}): PicsAction {
    return {type: SET_PICS, payload: pics}
}
export function setSettings(settings: SettingsType): SettingsAction {
    return {type: SET_SETTINGS, payload: settings}
}
